import React from "react";
import { Box, Typography } from "@mui/material";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import COLORS from "../../../../../constants/colors"; // Ensure this path is correct

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        const amount = payload[0].value;
        const formattedAmount = `UGX ${amount.toLocaleString("en-UG")}`;
        return (
            <Box sx={{
                backgroundColor: COLORS.primary,
                border: "none",
                color: '#fff',
                borderRadius: 2,
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                p: 1.5,
                minWidth: 120
            }}>
                <Typography variant="body2" fontWeight="bold">{label}</Typography>
                <Typography variant="body2" >Donations: {formattedAmount}</Typography>
            </Box>
        );
    }
    return null;
};

// The FundraisingChart component now receives the 'fundraisingData' as a prop
const FundraisingChart = ({ fundraisingData }) => {
    if (!fundraisingData) {
        return null; // Don't render if data is not available
    }

    return (
        <Box
            gridColumn={{ xs: "1 / -1" }}
            sx={{
                backgroundColor: "#fff",
                p: 3,
                borderRadius: 2,
                mt: 4,
                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                border: `1px solid ${COLORS.border}`,
            }}
        >
            <Box sx={{ mb: 2 }}>
                <Typography variant="h6" fontWeight="bold" sx={{ color: COLORS.text }}>
                    Fundraising Performance
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Monthly donations for the current year.
                </Typography>
            </Box>

            <ResponsiveContainer width="100%" height={300}>
                <LineChart
                    data={fundraisingData}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 40,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke={COLORS.border} vertical={false} />
                    <XAxis
                        dataKey="name"
                        stroke={COLORS.text}
                        tickLine={false}
                        axisLine={{ stroke: COLORS.border }}
                    />
                    <YAxis
                        stroke={COLORS.text}
                        tickLine={false}
                        axisLine={false}
                    />

                    <Tooltip content={<CustomTooltip />} />
                    <Line
                        type="monotone"
                        dataKey="amount"
                        stroke={COLORS.primary}
                        activeDot={{ r: 6, stroke: COLORS.primary, strokeWidth: 2, fill: '#fff' }}
                        strokeWidth={2}
                        dot={{ r: 4, fill: COLORS.primary, stroke: 'none' }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </Box>
    );
};

export default FundraisingChart;